import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0591f9a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d0591f9a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0591f9a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewSwitcher: require('/home/circleci/repo/components/ViewSwitcher.vue').default,Loader: require('/home/circleci/repo/components/Loader.vue').default})
